const Contants = {
  RECAPTCHA_PUBLIC: '6Ld-AJobAAAAAEgCJeE9Hy7Mi8wJL_bIYwUaxUuv',
  RECAPTCHA_SECRET: '6Ld-AJobAAAAAMfNOaHCTa_5uNK-MovJ3sIRRkN9',
};

export default Contants;
